<template>
    <div
        class="quote-progress"
        :class="{ full: full }"
        v-if="currentStep && currentStep.includeInCount"
    >
        <div class="progress-bar" :style="progressBarWidth">
            <img :src="icons[type]" alt="progress-icon" :style="cssVaribles" />
        </div>
    </div>
</template>

<script>
import carIcon from "../../../../public/images/progress/car-progress.svg";
import homeIcon from "../../../../public/images/progress/house-progress.svg";
import planeIcon from "../../../../public/images/progress/plane-progress.svg";
import petIcon from "../../../../public/images/progress/pet-progress.svg";

export default {
    props: {
        step: {
            type: Number,
            default: 0
        },
        subStep: {
            type: Number,
            default: 0
        },
        steps: {
            type: Array
        },
        progressSteps: {
            type: Array
        },
        stepOffset: {
            type: Number
        },
        notInCount: {
            type: Number
        },
        currentStep: {
            type: Object
        },
        full: {
            type: Boolean,
            default: false
        },
        static: {
            type: Object | Boolean,
            default: false
        },
        type: {
            type: String
        }
    },
    data() {
        return {
            icons: {
                car: carIcon,
                home: homeIcon,
                travel: planeIcon,
                pet: petIcon
            }
        };
    },
    computed: {
        progressBarWidth() {
            if (this.static) {
                const totalSteps = this.static.steps - 1;

                if (this.static.step > totalSteps) {
                    return {
                        width: "100%"
                    };
                }

                const totalSubSteps = this.static.subSteps;
                const currentStep = this.static.step;
                const currentSubStep = this.static.currentSubStep;

                let totalWidth = 0;
                let dividedWidth = 100 / totalSteps;

                // Advance the width by the current main step
                totalWidth += dividedWidth * (currentStep - 1);

                // Advance the width by the current sub step division multiplied by the width
                const stepWidthDivided = dividedWidth / totalSubSteps;

                totalWidth += currentSubStep * stepWidthDivided;

                return {
                    width: `${totalWidth}%`
                };
            }

            // Slice the total steps by 1 since we don't need the last step to be included in the progress bar!
            const totalSteps = this.progressSteps.slice(
                0,
                this.progressSteps.length - 1
            );

            // If is at last step, set progress bar width to 100
            if (this.step > totalSteps.length) {
                return {
                    width: "100%"
                };
            }

            const totalSubSteps = this.currentStep.totalSteps;
            // const totalSubSteps = 1;
            const currentStep = this.step;
            const currentSubStep = 1;

            // console.log('totalSubSteps', totalSubSteps);
            // console.log('currentStep', currentStep);
            // console.log('currentSubStep', currentSubStep);

            let totalWidth = 0;
            let dividedWidth = 100 / totalSteps.length;

            // Advance the width by the current main step
            totalSteps.forEach((stepItem, stepIndex) => {
                if (currentStep > stepIndex + this.notInCount) {
                    totalWidth += dividedWidth;
                }
            });

            totalWidth += dividedWidth * currentStep;

            return {
                width: `calc(${(currentStep / totalSteps.length) * 100}%)`
            };
        },

        offsetIcon() {
            switch (this.type) {
                case "car":
                    return { offsetLeft: "-70px", height: "75px", top: "17%" };
                case "home":
                    return {
                        offsetLeft: "-30px",
                        height: "75px",
                        top: "17%",
                        mobileOffset: "-40px"
                    };
                case "travel":
                    return {
                        offsetLeft: "-130px",
                        height: "140px",
                        top: "40%",
                        mobileHeight: "75px"
                    };
                case "pet":
                    return {
                        offsetLeft: "-80px",
                        height: "120px",
                        top: "0%",
                        mobileHeight: "100px"
                    };
                default:
                    return { offsetLeft: "-70px", height: "75px", top: "17%" };
            }
        },
        cssVaribles() {
            return {
                "--offset": this.offsetIcon.offsetLeft,
                "--height": this.offsetIcon.height,
                "--top": this.offsetIcon.top,
                "--mobileHeight": this.offsetIcon.mobileHeight ?? "50px",
                "--mobileOffset": this.offsetIcon.mobileOffset ?? "-70px"
            };
        }
    }
};
</script>

<style lang="scss">
.quote-progress {
    position: relative;
    margin-top: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 33px;
    border-radius: 100px;
    background: linear-gradient(
        270deg,
        rgba(224, 224, 224, 0.6) 0%,
        rgba(241, 241, 241, 0.39) 58.7%
    );
    z-index: -1;

    @media screen and (max-width: $tablet) {
        height: 24px;
        width: 90%;
    }

    @media screen and (max-width: $mobile) {
        align-self: flex-start;
        width: 85%;
    }

    &:after {
        position: absolute;
        content: "";
        background-size: 125px;
        height: 5px;
        background-image: url("data:image/svg+xml,%0A%3Csvg width='149' height='5' viewBox='0 0 149 5' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cline x1='-2.18557e-07' y1='2.5' x2='149' y2='2.49999' stroke='white' stroke-width='5'/%3E%3C/svg%3E%0A");
        background-repeat: space;
        width: 100%;
    }

    &:not(.full) {
        @media all and (max-width: $desktop) {
            margin-left: 0;
        }
    }

    .progress-bar {
        position: absolute;
        width: 100%;
        height: 33px;
        content: "";
        transition: all 0.2s ease-in-out;
        border-radius: 100px;
        background: $lighter-gray;
        z-index: 55555;

        @media screen and (max-width: $tablet) {
        }

        & img {
            position: absolute;
            left: var(--offset);
            display: block;
            background-size: contain;
            max-width: unset;
            height: var(--height);
            top: var(--top);
            transform: translateY(-50%);
            z-index: 55555;
            background-repeat: no-repeat;

            @media screen and (max-width: $mobile) {
                height: var(--mobileHeight);
                left: var(--mobileOffset);
            }
        }
    }

    .progress-item {
        position: relative;
        flex: 1;
        max-width: 15px;
        height: 15px;
        background-color: $lightest-gray;
        border-radius: 50%;
        z-index: 10;
        transition: all 0.2s ease-in-out;

        @media all and (max-width: $mobile) {
            max-width: 9px;
            height: 9px;
        }

        &.active {
            background-color: $primary-blue;

            &:after {
                position: absolute;
                top: -6px;
                left: -6px;
                border-radius: 50%;
                content: "";
                width: 23px;
                height: 23px;
                border: solid 2px $primary-blue;
                background-color: transparent;

                @media all and (max-width: $mobile) {
                    width: 17px;
                    height: 17px;
                }
            }
        }

        .progress-title {
            position: absolute;
            font-size: 20px;
            font-weight: bold;
            line-height: 1.3;
            color: $primary-blue;
            left: 50%;
            transform: translateX(-50%);
            white-space: nowrap;
            top: -45px;

            @media all and (max-width: $mobile) {
                font-size: 15px;
                font-weight: bold;
                font-stretch: normal;
                font-style: normal;
                line-height: 1.27;
                top: -25px;
            }
        }
    }
}
</style>
